import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../../styles/exportExcelPopup.module.css";

function MultiTeamsReportPopup({ isOpen, onClose, onConfirm }) {
    const { t } = useTranslation();
    const [nombreEquipo, setNombreEquipo] = useState("");
    const [nombreResponsable, setNombreResponsable] = useState("");

    if (!isOpen) return null;

    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const handleConfirm = () => {
        onConfirm({ nombreEquipo: nombreEquipo.trim(), nombreResponsable: nombreResponsable.trim() });
        setNombreEquipo("");
        setNombreResponsable("");
        onClose();
    };

    return (
        <div className={styles.popupOverlay} onClick={handleClickOutside}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <h2>{t("multiTeamsReport.title")}</h2>
                <p className={styles.subtitle}>{t("multiTeamsReport.subtitle")}</p>
                <div className={styles.optionGroup}>
                    <label>{t("multiTeamsReport.teamName")}</label>
                    <input
                        type="text"
                        value={nombreEquipo}
                        onChange={(e) => setNombreEquipo(e.target.value)}
                        placeholder={t("multiTeamsReport.teamNamePlaceholder")}
                        style={{ padding: "0.5rem", border: "1px solid #ddd", borderRadius: "7px", fontSize: "0.9rem", width: "100%" }}
                    />
                </div>
                <div className={styles.optionGroup}>
                    <label>{t("multiTeamsReport.responsibleName")}</label>
                    <input
                        type="text"
                        value={nombreResponsable}
                        onChange={(e) => setNombreResponsable(e.target.value)}
                        placeholder={t("multiTeamsReport.responsiblePlaceholder")}
                        style={{ padding: "0.5rem", border: "1px solid #ddd", borderRadius: "7px", fontSize: "0.9rem", width: "100%" }}
                    />
                </div>
                <div className={styles.popupActions}>
                    <button type="button" className={styles.buttonCancel} onClick={onClose}>
                        {t("cancel")}
                    </button>
                    <button type="button" className={styles.buttonExport} onClick={handleConfirm}>
                        {t("multiTeamsReport.generate")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MultiTeamsReportPopup;
